import React from 'react'

const DashboardCardShimmer = () => {
  return (
    <div className="p-5 bg-white rounded-lg shadow">
        <div className="animate-pulse">
            <div className="flex items-center justify-between">
                <div className="p-3 rounded-lg bg-slate-200">
                    <div className="w-10 h-10" />
                </div>
                <div className="text-4xl font-semibold text-slate-200">???</div>
            </div>
            <div className="float-right w-1/2 h-3 mt-2 rounded bg-slate-200"></div>
        </div>
    </div>
  )
}

export default DashboardCardShimmer